/****************************************************************************
*			       Copyright © 2023 HeartcoR Solutions
*                        All rights reserved.
*		Developed under contract by CriTech Research, Inc.
*
* File Name:    HeartcoR_Common_Clear.js
* Project: 		HeartcoR EDAAS End-To-End Anomaly Corrections
* File Type:	Javascript File
* Description:  Namespace implemented to match NET Common routines on the Heartcor.Common Assembly.
*               Encryption is made using the Stanford Javascript Crypto Library
*               Encrypt the text received as a symmetric AES-256 format
*               ***NOTE*** To Publish this file on production, please convert use
*               an obfuscator tool with self defending and debug protection features activated
*               Replace the content of HeartcoR_Common_Release.js with the obfuscated code.
*
* Revision History: 
* Date       * Engineer * ECP   * Changes
* 2023-06-07 * CED      * 0001  * Implemented changes to fix Anomaly #209.
*                                 Password not encrypted during transmission
* 2023-06-20 * CED      * 0001  * Updated per CRI-81532-SCRR1001-0100-RR0001-0100
*****************************************************************************/
import sjcl from 'sjcl';

var AESKey = "";
var AESIV = "";
/****************************************************************************
*  Name: SetPasswordKeys
*
*  Description: Set local encryption key and initialization vector.
*
*  Interface:
*    Parameters:
*      Name:               In / Out / In-Out          Range
*      key                 In                         Private
*      iv                  In                         Private
*
*    Globals:
*      Name:               In / Out / In-Out          Range
*      AESKey              In-Out                     Private
*      AESIV               In-Out                     Private
*
*  Returns: None
*
*****************************************************************************/
export function setPasswordKeys(key, iv) {
    AESKey = key;
    AESIV = iv;
}
/****************************************************************************
*  Name: EncryptPassword
*
*  Description: Encrypt the text received using the encryption key and the initialization vector.
*
*  Interface:
*    Parameters:
*      Name:               In / Out / In-Out          Range
*      textToEncrypt       In                         Private
*
*    Globals:
*      Name:               In / Out / In-Out          Range
*      None                N/A                        N/A
*
*  Returns: Returns the encrypted text
*
*  Notes: Function updated per bug # 209 Password not encrypted during transmission
*
*****************************************************************************/
export function EncryptPassword(textToEncrypt) {
    let EncryptedPassword = sjcl.encrypt(AESKey, textToEncrypt, {
        iv: AESIV,
        v: 1,
        iter: 1000,
        ks: 256,
        ts: 128,
        mode: "ccm",
        adata: "",
        cipher: "aes",
        salt: ""
    });
    EncryptedPassword = JSON.parse(EncryptedPassword);
    EncryptedPassword = EncryptedPassword["ct"];
    return EncryptedPassword;
}


// WEBPACK FOOTER //
// ./src/data/HeartcoR_Common.js